import type { ISessionDto } from 'dtos/session.dto';
import type { ISession } from 'types/session.type';

export class SessionAdapter {
  static dtoToModel(dto: ISessionDto): ISession {
    return { ...dto };
  }
}
